import React from 'react';
import { DisplayText, TextStyle } from '@superops/ui-design-system';
import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import ConnectionCheckerContainer from '@nile/home/src/ConnectionCheckerContainer';

const ErrorPageModule = (props) => {
  const {
    imageURL,
    text,
    description,
    showRefreshBtn = false,
    width,
    height,
    contactSupport
  } = props;

  return (
    <div className="fx bg-white actr jctr col fh">
      <div className="fx actr">
        <div className="flex col jctr">
          <div className="maxW400">
            <DisplayText size="extraLarge" element="h1" weight="Bold">
              {text}
            </DisplayText>
          </div>
          <div className="maxW400 pr100 mt10">
            <TextStyle variation="subdued">{description}</TextStyle>
          </div>
          {contactSupport && (
            <div className="maxW400 pr100 mt10">
              <TextStyle variation="subdued">
                If you believe this is an error, or if you need assistance, feel
                free to reach out to our support team. We're here to help!{' '}
              </TextStyle>
              <br></br>
              <TextStyle>[Contact : Support@superops.com]</TextStyle>
            </div>
          )}
          {showRefreshBtn && (
            <div className="mt-20 flex gap-10">
              <div className="ptr" onClick={() => window.location.reload()}>
                <TextStyle weight="Medium">Refresh</TextStyle>
              </div>
            </div>
          )}
        </div>
        <BackgroundIcon
          url={imageURL}
          height={height || '170px'}
          width={width || '200px'}
        />
      </div>
      {/* <ConnectionCheckerContainer origin="errorPage" /> */}
    </div>
  );
};

const DomainErrorPage = (props) => {
  switch (props.errorCode) {
    case 404:
      return (
        <ErrorPageModule
          imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
          text="Oops! The Page Can't Be Found"
          description="It seems the URL you entered doesn't match any of our pages. Please double-check the web address for accuracy."
          contactSupport
        />
      );
    case 503:
    case 504:
      return (
        <ErrorPageModule
          imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
          text="Service Unavailable"
          description="Service is currently unavailable. The application will be temporarily inaccessible"
          showRefreshBtn
        />
      );
    default:
      return (
        <ErrorPageModule
          imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
          text="Something went wrong"
          description="Something went wrong while trying to connect with the application. Please try again in some time"
          showRefreshBtn
        />
      );
  }
};

export default DomainErrorPage;
